<template>
  <v-dialog>
    <template v-slot:activator="{ props: activatorProps }">
      <v-row>
        <v-col>
          <v-card link v-bind="activatorProps" @click="recordView()">
            <v-container fluid>
              <v-row class="d-lg-none">
                <v-col align="center" cols="12" lg="6">
                  <v-row>
                    <v-col cols="12" :class="textClass + ' text-h6'">{{ person.firstname }} {{ person.lastname }}</v-col>
                    <v-col cols="12" :class="textClass + ' text-subtitle-1'">{{ person.cemeteryname }}</v-col>
                  </v-row>
                </v-col>
                <v-col align="center" cols="12" lg="6">
                  <v-row>
                    <v-col cols="12" v-if="person.deathday || person.deathmonth || person.deathyear">
                      <v-icon>mdi-grave-stone</v-icon> <v-chip>{{ person.deathday }} {{ person.deathmonth }} {{ person.deathyear }}</v-chip>
                    </v-col>
                    <v-col v-if="spaceinfo">
                      Burial Space: <v-chip>{{ spaceinfo.sectionname }}-{{ spaceinfo.lotname }}-{{ spaceinfo.spacename }}</v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="d-none d-xs-none d-sm-none d-md-none d-lg-flex">
                <v-col cols="12" lg="6">
                  <v-row>
                    <v-col cols="12" :class="textClass + ' text-h6'">{{ person.firstname }} {{ person.lastname }}</v-col>
                    <v-col cols="12" :class="textClass + ' text-subtitle-1'">{{ person.cemeteryname }}</v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-row>
                    <v-col cols="12" v-if="person.deathday || person.deathmonth || person.deathyear">
                      <v-icon>mdi-grave-stone</v-icon> <v-chip>{{ person.deathday }} {{ person.deathmonth }} {{ person.deathyear }}</v-chip>
                    </v-col>
                    <v-col v-if="spaceinfo">
                      Burial Space: <v-chip>{{ spaceinfo.sectionname }}-{{ spaceinfo.lotname }}-{{ spaceinfo.spacename }}</v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card>
        <v-card-title>Person Details</v-card-title>

        <v-card-item class="text-h6">{{ person.firstname }} {{ person.lastname }}</v-card-item>

        <v-card-item>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="text-subtitle-2">Cemetery:</v-col>
                <v-col cols="12"><a :href="'/cemetery/' + person.slug">{{ person.cemeteryname }}</a></v-col>
              </v-row>
              <v-row v-if="spaceinfo">
                <v-col cols="12" class="text-subtitle-2">Space:</v-col>
                <v-col cols="12">{{ spaceinfo.sectionname }}-{{ spaceinfo.lotname }}-{{ spaceinfo.spacename }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-item>

        <v-card-item>
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="text-subtitle-2">Spouse:</v-col>
                <v-col cols="12">{{ person.spouse }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-item>

        <v-card-item>
          <v-row>
            <v-col cols="4">
              <v-row>
                <v-col cols="12" class="text-subtitle-2">Birth Date:</v-col>
                <v-col cols="12">{{ person.birthday }} {{ person.birthmonth }} {{ person.birthyear }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="4" v-if="person.deceased">
              <v-row>
                <v-col cols="12" class="text-subtitle-2">Death Date:</v-col>
                <v-col cols="12">{{ person.deathday }} {{ person.deathmonth }} {{ person.deathyear }}</v-col>
              </v-row>
            </v-col>
            <v-col cols="4" v-if="person.deceased">
              <v-row>
                <v-col cols="12" class="text-subtitle-2">Approx Age:</v-col>
                <v-col cols="12">{{ person.deathyear - person.birthyear > 110 ? "N/A" : person.deathyear - person.birthyear }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-item>

        <v-card-item v-if="person.publicnotes && person.publicnotes.length > 0">
          <v-row>
            <v-col cols="12" class="text-subtitle-2">Public Records:</v-col>
            <v-col cols="12">{{ person.publicnotes }}</v-col>
          </v-row> 
        </v-card-item>

        <v-card-actions>
          <v-spacer />
          <AddChangeRequestDialog :person="person" />
          <v-btn text="Close" @click="isActive.value = false" />
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import AddChangeRequestDialog from './AddChangeRequestDialog.vue';

export default {
  name: 'PersonDialog',

  components : {
    AddChangeRequestDialog
  },

  props:{
    person : Object,
    cemeteries : Array
  },

  data: () => ({
    spaceinfo : null,
  }),

  created : function(){
    fetch("https://app.cemeterycommunity.com:11000/api/getspacebyburialid", { method: "POST", headers : { data : JSON.stringify({ burialid : this.person.id }) } })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results == "Failed" ) return;
        else this.spaceinfo = res.results[0];
      });
  },

  methods:{
    getAdStatus(){
      
    },
    recordView(){
      fetch("https://app.cemeterycommunity.com:11000/api/viewrecord", { method: "POST", headers : { data : JSON.stringify( { cemeteryid : this.person.cemeteryid, search : this.person.firstname + ' ' + this.person.lastname } ) } });
    }
  }
}
</script>